module.exports = __webpack_public_path__ + "img/hero_bg_mobile_1x.741068f.jpg";